import { INSTANCE } from './endpoint';

const getToken = () => `Bearer ${localStorage.getItem('token')}`;

export const listContentLogsDirApi = (dirPath: string) =>
  INSTANCE.get(`/v1/admin/contentLogs${dirPath ? '/' + dirPath : ''}`, {
    headers: { Authorization: getToken() },
  }).then((res) => res.data);

export const readContentLogFileApi = (filePath: string) =>
  INSTANCE.get(`/v1/admin/contentLogs/${filePath}`, {
    headers: { Authorization: getToken() },
  }).then((res) => res.data);
